"use client";

import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../../../utils";

export interface CellLoadingProps {
  /** Optional label, e.g. "queued" vs "running". */
  label?: string;
  className?: string;
}

/**
 * Spinner-only cell renderer used while a cell run is `queued` or `running`.
 * No value content, no badges.
 */
export function CellLoading({ label, className }: CellLoadingProps) {
  return (
    <span
      className={cn("inline-flex items-center gap-1.5 text-sm text-muted-foreground", className)}
      aria-live="polite"
      aria-busy="true"
    >
      <Loader2 className="size-3.5 animate-spin" aria-hidden="true" />
      {label ? <span>{label}</span> : null}
    </span>
  );
}
